export default __webpack_public_path__ + "static/media/sticker-10.49e887cb.png";